import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UIModalService } from '@shared/ui';
import { Observable, of } from 'rxjs';
import { LocalizationPipe } from '@shared/modules/localization';

@Injectable({ providedIn: 'root' })
export class DeactivationConfirmService {
  modalService = inject(UIModalService);
  localization = inject(LocalizationPipe);

  confirmDeactivation(isEditing: boolean, destroyRef: DestroyRef): Observable<boolean> {
    if (!isEditing) {
      return of(true);
    }

    return new Observable<boolean>(observer => {
      this.modalService
        .confirm({
          title: this.localization.transform('ADMIN_DEACTIVATION_CONFIRM_TITLE'),
          desctiption: this.localization.transform('ADMIN_DEACTIVATION_CONFIRM_DESCRIPTION'),
        })
        .pipe(takeUntilDestroyed(destroyRef))
        .subscribe(isConfirmed => {
          if (isConfirmed) {
            observer.next(isConfirmed);
            observer.complete();
          }
        });
    });
  }
}
